import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Calendar, Bell, HeartPulse, Settings } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Mobile bottom tab bar — visible only on small screens (md:hidden).
 * 5 tabs matching the desktop sidebar navigation.
 */
export const MobileTabBar = () => {
  const { user } = useAuth();
  const location = useLocation();
  const familyId = user?.familyId || localStorage.getItem('family_id');

  const tabs = [
    { to: `/parent?family_id=${familyId}`, icon: Calendar, label: 'Today', match: (p) => p === '/parent' || p === '/parent/today' },
    { to: `/parent/updates?family_id=${familyId}`, icon: Bell, label: 'Updates', match: (p) => p.startsWith('/parent/updates') || p.startsWith('/parent/inbox') },
    { to: `/parent/care?family_id=${familyId}`, icon: HeartPulse, label: 'Care', match: (p) => p.startsWith('/parent/care') },
    { to: `/parent/settings?family_id=${familyId}`, icon: Settings, label: 'Settings', match: (p) => p.startsWith('/parent/settings') },
  ];

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-100 md:hidden"
      data-testid="mobile-tab-bar"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className="flex items-center justify-around h-14">
        {tabs.map(({ to, icon: Icon, label, match }) => {
          const isActive = match(location.pathname);
          return (
            <NavLink
              key={label}
              to={to}
              className="flex flex-col items-center justify-center flex-1 h-full gap-0.5"
              data-testid={`tab-${label.toLowerCase()}`}
            >
              <Icon
                className={`w-5 h-5 ${isActive ? 'text-primary' : 'text-slate-400'}`}
                strokeWidth={isActive ? 2.2 : 1.8}
              />
              <span className={`text-[10px] font-medium ${isActive ? 'text-primary' : 'text-slate-400'}`}>
                {label}
              </span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileTabBar;
